import { Entry } from '../Entry'

export function Entry20241023() {
  return (
    <Entry title="23/10/2024 - v3.8.6">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16132/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
